import { ModuleWithProviders, NgModule } from '@angular/core';
import { ioteqConfigService } from '@tools/services/config/config.service';
import { IOTEQ_APP_CONFIG } from '@tools/services/config/config.constants';

@NgModule()
export class ioteqConfigModule
{
    /**
     * Constructor
     */
    constructor(private _ioteqConfigService: ioteqConfigService)
    {
    }

    /**
     * forRoot method for setting user configuration
     *
     * @param config
     */
    static forRoot(config: any): ModuleWithProviders<ioteqConfigModule>
    {
        return {
            ngModule : ioteqConfigModule,
            providers: [
                {
                    provide : IOTEQ_APP_CONFIG,
                    useValue: config
                }
            ]
        };
    }
}
